import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
// import Link from "@mui/material/Link";
import { useCart } from "../context/CartContext";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { keyframes, styled } from "@mui/system";

// import StripeCheckoutButton from "../components/StripeCheckoutButton";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

// // Load your publishable key
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const HungryAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
`;

const HungryIcon = styled(AddShoppingCartIcon)(({ theme }) => ({
  fontSize: 60,
  animation: `${HungryAnimation} 2s ease-in-out infinite`,
}));

const ShoppingCart = () => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const {
    cart,
    addToCart,
    removeProduct,
    total,
    subtotal,
    deliveryCharge,
    discount,
  } = useCart();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const incrementQuantity = (item) => {
    addToCart(item, item.quantity + 1, true);
  };

  const decrementQuantity = (item) => {
    addToCart(item, item.quantity - 1, false);
  };

  const handleRemoveProduct = (id) => {
    const item = cart.find((item) => item._id === id);
    removeProduct(id);
    setSnackbarMessage(`${item ? item.name : "Item"} removed from cart!`);
    setSnackbarOpen(true);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 12 }}>
      <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
        Food Cart
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          {cart.length > 0 ? (
            cart?.map((item, index) => (
              <Card
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  mb: 2,
                  alignItems: "center",
                  p: 1,
                }}
              >
                <CardMedia
                  sx={{ width: 190, height: 190, backgroundSize: "contain" }}
                  image={item.image}
                  title={item.name}
                />
                <CardContent
                  sx={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {item.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {item.description}
                  </Typography>
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: "bold" }}
                  >
                    ₹{item.price}
                  </Typography>
                </CardContent>
                <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
                  <IconButton
                    onClick={() => decrementQuantity(item)}
                    disabled={item.quantity <= 1}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <Typography sx={{ mx: 2 }}>{item.quantity}</Typography>
                  <IconButton onClick={() => incrementQuantity(item)}>
                    <AddIcon />
                  </IconButton>
                </Box>
                <IconButton
                  onClick={() => handleRemoveProduct(item._id)}
                  sx={{ ml: "auto" }}
                >
                  <CloseIcon />
                </IconButton>
              </Card>
            ))
          ) : (
            <Box sx={{ textAlign: "center", my: 4 }}>
              <HungryIcon />
              {/* <AddShoppingCartIcon sx={{ fontSize: 60 }} /> */}
              <Typography variant="h4" component="h2">
                Let's order some food!
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => {
                  navigate("/menu");
                }}
              >
                Go to Menu
              </Button>
            </Box>
          )}
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ my: 2 }}>
            <Typography variant="h5">Summary</Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography>Subtotal</Typography>
              <Typography>₹{subtotal.toFixed(2)}</Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography>Delivery Charge</Typography>
              <Typography>₹{deliveryCharge.toFixed(2)}</Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography>Discount</Typography>
              <Typography>-₹{discount.toFixed(2)}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 1,
                fontWeight: "bold",
              }}
            >
              <Typography>Total Price</Typography>
              <Typography>₹{total.toFixed(2)}</Typography>
            </Box>
          </Box>

          <Button
            disabled={cart.length > 0 ? false : true}
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() =>
              isAuthenticated ? navigate("/checkout") : navigate("/signin")
            }
          >
            Continue to checkout
          </Button>

          {/* <Elements stripe={stripePromise}>
            <StripeCheckoutButton />
          </Elements>
          <Link href="https://buy.stripe.com/test_dR69BH7HYg094rCdQQ">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
            >
              BUY
            </Button>
          </Link> */}

          <Button
            variant="outlined"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => navigate("/menu")}
          >
            Back to Menu
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ShoppingCart;
